import React from 'react';
import { useTranslation } from 'react-i18next';
import FeatureCards from "../../../../components/FeatureCards/FeatureCards";
import CTA from "../../../../components/Constant/cta/CTA";
import TimelineSection from "../../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../../components/WhySection/WhySection";
import LocationTimeline from "../../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import SEO from "../../../../utils/SEO";

export default function SingaporeCompanyForSaleWithBankAccount() {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.singapore-company-for-sale-with-bank-account.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/singapore-company-for-sale-with-bank-account"
            />

            <IntroSection
                title={tp('intro.title')}
                subtitle={tp('intro.subtitle')}
                description={tp('intro.description')}
                badges={obj('intro.badges')}
                buttonText={tp('intro.button')}
                buttonLink="/quote"
                imageSrc={require("../../../../assets/images/singapore-company-for-sale-with-bank-account.png")}
                imageAlt={tp('intro.imageAlt')}
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title={tp('why.title')}
                        subtitle={tp('why.subtitle')}
                        blocks={[{ items: obj('why.items') }]}
                        end={tp('why.end')}
                    />

                    <LocationTimeline
                        title={tp('includes.title')}
                        subtitle={tp('includes.subtitle')}
                        item={obj('includes.item')}
                        end={tp('includes.end')}
                    />

                    <WhySection
                        title={tp('bankAccount.title')}
                        subtitle={tp('bankAccount.subtitle')}
                        blocks={[{ items: obj('bankAccount.items') }]}
                        end={tp('bankAccount.end')}
                    />

                    <InfoBlocks
                        title={tp('localDirector.title')}
                        subtitle={tp('localDirector.subtitle')}
                        blocks={obj('localDirector.blocks')}
                        end={tp('localDirector.end')}
                    />

                    <DetailsSection
                        title={tp('nominee.title')}
                        subtitle={tp('nominee.subtitle')}
                        items={obj('nominee.items')}
                        end={tp('nominee.end')}
                    />

                    <WhySection
                        title={tp('privacy.title')}
                        subtitle={tp('privacy.subtitle')}
                        blocks={[{ items: obj('privacy.items') }]}
                        end={tp('privacy.end')}
                    />

                    <FeatureCards
                        title={tp('tax.title')}
                        subtitle={tp('tax.subtitle')}
                        features={obj('tax.features')}
                        end={tp('tax.end')}
                    />

                    <InfoBlocks
                        title={tp('dueDiligence.title')}
                        subtitle={tp('dueDiligence.subtitle')}
                        blocks={obj('dueDiligence.blocks')}
                        end={tp('dueDiligence.end')}
                    />

                    <WhySection
                        title={tp('shelf.title')}
                        subtitle={tp('shelf.subtitle')}
                        blocks={[{ items: obj('shelf.items') }]}
                        end={tp('shelf.end')}
                    />

                    <TimelineSection
                        title={tp('process.title')}
                        items={obj('process.items')}
                    />

                    <FeatureCards
                        title={tp('useCases.title')}
                        subtitle={tp('useCases.subtitle')}
                        features={obj('useCases.features')}
                        end={tp('useCases.end')}
                    />

                    <FAQList data={obj('faq.items')} title={tp('faq.title')} />

                    <CTA
                        title={tp('cta.title')}
                        description={tp('cta.description')}
                        buttonText={tp('cta.button')}
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
}
